import {
  DASHBOARD_STATISTICS,
  GRAPH_OF_STATISTICS,
  LIST_OF_TOP_CUSTOMERS,
} from "./ApiRoutes";
import { authData } from "./services";

export const dashboardStatistics = async (data: object) => {
  const response = await authData.post(DASHBOARD_STATISTICS, data);
  return response?.data;
};

export const listOfTopCustomers = async (data: object) => {
  const response = await authData.post(LIST_OF_TOP_CUSTOMERS, data);
  return response?.data;
};

export const graphOfStatistics = async (data: object) => {
  const response = await authData.post(GRAPH_OF_STATISTICS, data);
  return response?.data;
};
